// /* eslint-disable react-hooks/exhaustive-deps */
// import React from "react";
// import { useSelector } from "react-redux";
// import { FaPhone } from "react-icons/fa6";
// import { FaVideo } from "react-icons/fa6";

// export default function IncomingCallModal({ data, onAccept, onReject }) {
//   const { selectedAppt } = useSelector((state) => state.user);


//   if (!data || data.length === 0) return null;

//   const getInitial = (name) => {
//     if (!name) return "?";

//     const words = name.replace(/^(Dr|Mr|Mrs|Ms|Ms)\.?/i, "").trim();

//     return words[0]?.toUpperCase() || "?";
//   };



//   return (
//     // <div className="incoming-call-container">
//     //   {
//     //     data && data?.filter((item) => selectedAppt ? item.incomingCall.roomId !== selectedAppt.appointmentId : true).map((item) => (
//     //       <div className="incoming-call-modal flex flex-col justify-between ">
//     //         <div>
//     //           <p><span className="font-semibold">{item?.incomingCall?.callerName}</span> is waiting for you. Please join the call.</p>
//     //         </div>
//     //         <div className="incoming-call-actions">
//     //           <button className="reject-btn" onClick={() => onReject(item?.incomingCall?.roomId)}>Cancel</button>
//     //           <button className="accept-btn" onClick={() => onAccept(item?.incomingCall?.roomId)}>Join</button>
//     //         </div>
//     //       </div>
//     //     ))
//     //   }

//     // </div>
//     <div className="incoming-call-container">
//       {
//         data && data?.filter((item) => selectedAppt ? item.incomingCall.roomId !== selectedAppt.appointmentId : true).map((item) => (
//           <div className="relative w-[370px] rounded-2xl p-[2px] bg-gradient-to-r from-[#76ADCC] via-[#5fb3b0] to-[#6bc7a6] shadow-xl">
//             <div className="relative rounded-md bg-gradient-to-r from-[#6fb0cc]/95 via-[#5fb3b0]/95 to-[#6bc7a6]/95 backdrop-blur-md px-4 py-2 text-white">
//               {/* <button className="absolute right-6 top-6 text-white/80 hover:text-white transition">
//                 <span className="text-lg">X</span>
//               </button> */}
//               <div className="flex items-center gap-3">
//                 <div className="relative flex items-center justify-center w-10 h-10 rounded-full border-2 border-white/70 text-lg font-semibold">
//                   {getInitial(item?.incomingCall?.callerName)}
//                   <span className="absolute top-1 right-1 w-2 h-2 bg-green-400 rounded-full border-2 border-white"></span>
//                 </div>
//                 <div>
//                   <p className="text-lg opacity-90">Incoming Call</p>
//                   <h2 className="text-lg font-semibold mt-1">
//                     {item?.incomingCall?.callerName}
//                   </h2>
//                   <p className="opacity-80 mt-1">
//                     is waiting for you...
//                   </p>
//                 </div>
//               </div>
//               <div className="h-px bg-white/30 my-2"></div>
//               <div className="flex items-center justify-between px-12">
//                 <div className="flex flex-col items-center gap-3">
//                   <button
//                     onClick={() => onReject(item?.incomingCall?.roomId)}
//                     className="w-10 h-10 rounded-full bg-white text-teal-500 flex items-center justify-center shadow-lg hover:scale-105 active:scale-95 transition"
//                   >
//                     <FaPhone className="text-xl" />
//                   </button>
//                   <span className="text-base opacity-90">Decline</span>
//                 </div>

//                 <div className="flex flex-col items-center gap-3">
//                   <button
//                     onClick={() => onAccept(item?.incomingCall?.roomId)}
//                     className="w-10 h-10 rounded-full bg-gradient-to-br from-[#64d2b0] to-[#49a6a6] flex items-center justify-center shadow-lg hover:scale-105 active:scale-95 transition">
//                     <FaVideo className="text-xl" />
//                   </button>
//                   <span className="text-base opacity-90">Join Call</span>
//                 </div>

//               </div>
//             </div>
//           </div>
//         ))
//       }
//     </div>

//   );
// }

// ─────────────────────────────────────────────────────────────────────────────
// SHARED — IncomingCallModal.jsx
// Used by both Doctor app and Patient app (identical logic).
//
// KEY BEHAVIOUR:
//   - Filters out notifications for the room the user is ALREADY IN.
//     This covers the "joined via appointment page" scenario:
//     the other side may have a status-1 doc in Firestore, but since
//     selectedAppt.appointmentId matches, we suppress it here.
//   - Renders nothing if no visible calls remain after filtering.
// ─────────────────────────────────────────────────────────────────────────────
/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useSelector } from "react-redux";
import { FaPhone } from "react-icons/fa6";
import { FaVideo } from "react-icons/fa6";

/**
 * @param {object[]} data        - Array of call notification objects from Firestore
 * @param {function} onAccept    - (roomId: string) => void
 * @param {function} onReject    - (roomId: string) => void
 */
export default function IncomingCallModal({ data, onAccept, onReject }) {
  // Works for both apps:
  //   Doctor app stores selected appointment in state.user.selectedAppt
  //   Patient app stores selected appointment in state.appt.selectedAppt
  // Pass the right selector from the parent (via a prop or context),
  // or keep two versions of this file with the correct selector.
  // Here we try both; whichever returns a value is used.
  const doctorSelectedAppt = useSelector((state) => state.user?.selectedAppt);
  const selectedAppt = doctorSelectedAppt;

  if (!data || data.length === 0) return null;

  /**
   * KEY FIX — "Join via appointment page" scenario:
   *
   * If the user is already inside a video room (selectedAppt is set),
   * we filter out any notification whose roomId matches that appointment.
   * This prevents showing a call popup to someone who is already in the call.
   *
   * Why this works:
   * - Person A rejects the call notification but navigates to the video room
   *   via the appointment card/dashboard. At that point selectedAppt is set
   *   to that appointmentId.
   * - The Firestore doc may still have status == 1 (if Person B hasn't left yet),
   *   so the snapshot listener still returns it.
   * - But this filter hides it because the roomId matches selectedAppt.
   */
  const visibleCalls = data
  // .filter((item) =>item.incomingCall.roomId !== selectedAppt?.appointmentId);

  if (visibleCalls.length === 0) return null;

  const getInitial = (name) => {
    if (!name) return "?";
    const cleaned = name.replace(/^(Dr|Mr|Mrs|Ms|Ms)\.?\s*/i, "").trim();
    return cleaned[0]?.toUpperCase() || "?";
  };

  return (
    <div className="incoming-call-container">
      {visibleCalls.map((item) => (
        <div
          key={item.incomingCall.roomId}
          className="relative w-[370px] rounded-2xl p-[2px] bg-gradient-to-r from-[#76ADCC] via-[#5fb3b0] to-[#6bc7a6] shadow-xl"
        >
          <div className="relative rounded-md bg-gradient-to-r from-[#6fb0cc]/95 via-[#5fb3b0]/95 to-[#6bc7a6]/95 backdrop-blur-md px-4 py-2 text-white">
            <div className="flex items-center gap-3">
              <div className="relative flex items-center justify-center w-10 h-10 rounded-full border-2 border-white/70 text-lg font-semibold">
                {getInitial(item?.incomingCall?.callerName)}
                <span className="absolute top-1 right-1 w-2 h-2 bg-green-400 rounded-full border-2 border-white" />
              </div>
              <div>
                <p className="text-lg opacity-90">Incoming Call</p>
                <h2 className="text-lg font-semibold mt-1">
                  {item?.incomingCall?.callerName}
                </h2>
                <p className="opacity-80 mt-1">is waiting for you...</p>
              </div>
            </div>

            <div className="h-px bg-white/30 my-2" />

            <div className="flex items-center justify-between px-12">
              <div className="flex flex-col items-center gap-3">
                <button
                  onClick={() => onReject(item?.incomingCall?.roomId)}
                  className="w-10 h-10 rounded-full bg-white text-teal-500 flex items-center justify-center shadow-lg hover:scale-105 active:scale-95 transition"
                >
                  <FaPhone className="text-xl" />
                </button>
                <span className="text-base opacity-90">Decline</span>
              </div>

              <div className="flex flex-col items-center gap-3">
                <button
                  onClick={() => onAccept(item?.incomingCall?.roomId)}
                  className="w-10 h-10 rounded-full bg-gradient-to-br from-[#64d2b0] to-[#49a6a6] flex items-center justify-center shadow-lg hover:scale-105 active:scale-95 transition"
                >
                  <FaVideo className="text-xl" />
                </button>
                <span className="text-base opacity-90">Join Call</span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
